import React, { useEffect, useState,useContext } from "react";
import { Button, Row, Col, Radio, Tag, Spin } from "antd";
import { SaveOutlined, InfoCircleOutlined } from "@ant-design/icons";
import {
  Paper,
  TextField,
  Box,
  Typography,
  Divider,
  Button as MUIButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { URL as BASE_URL } from "../config";
import { LoaderContext } from "../Components/dashboard";
const themeColor = "#ff002b";

export default function SongMainTypeForm() {
  const { setLoading } = useContext(LoaderContext);
  const { id } = useParams(); 
  const navigate = useNavigate();

const [saving, setSaving] = useState(false);

  const [mainTypeName, setMainTypeName] = useState("");
  const [isActive, setIsActive] = useState(1);
  const [photoFile, setPhotoFile] = useState(null);
  const [filePreviewProfile, setFilePreviewProfile] = useState("");
const [removeImage, setRemoveImage] = useState(false);

  const [mode, setMode] = useState(id ? "edit" : "create"); 
useEffect(() => {
  let isMounted = true;
  const startTime = Date.now();

  setLoading(true); 

  const init = async () => {
    if (id) {
      await fetchDetails(); 
    }

    const elapsed = Date.now() - startTime;
    const remaining = 1500 - elapsed;

    setTimeout(() => {
      if (isMounted) {
        setLoading(false); 
      }
    }, remaining > 0 ? remaining : 0);
  };

  init();

  return () => {
    isMounted = false;
  };
}, [id]);
  useEffect(() => {
    setMode(id ? "edit" : "create");
    if (id) fetchDetails();
  }, [id]);

  const fetchDetails = async () => {
    try {
      
      const res = await axios.get(`${BASE_URL}/songmaintype/${id}`);
      const data = res.data.data;

      setMainTypeName(data.mainTypeName || "");
      setIsActive(data.isActive ?? 1);
 setRemoveImage(false);
      if (data.mainTypePhoto) {
        const previewUrl = data.mainTypePhoto.startsWith("http")
          ? data.mainTypePhoto
          : `${BASE_URL}${data.mainTypePhoto}`;
        setFilePreviewProfile(previewUrl);
      } else {
        setFilePreviewProfile("");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to load details");
    } finally {
    
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhotoFile(file);
      setFilePreviewProfile(URL.createObjectURL(file));
    }
  };

  const removeFile = () => {
    setPhotoFile(null);
    setFilePreviewProfile("");
    setRemoveImage(true);
  };

  const clearForm = () => {
    setMainTypeName("");
    setIsActive(1);
    setPhotoFile(null);
    setFilePreviewProfile("");
  };

  const handleSave = async () => {
    if (saving) return;
    if (!mainTypeName.trim()) {
      toast.error("Main type name is required");
      return;
    }

    try {
      setSaving(true);
      const formData = new FormData();
      formData.append("mainTypeName", mainTypeName);
      formData.append("isActive", isActive);
      if (photoFile) formData.append("mainTypePhoto", photoFile);
if (removeImage) {
      formData.append("removeImage", "1");
    }
      if (mode === "edit") {
      
        await axios.patch(`${BASE_URL}/songmaintype/${id}`, formData);
        toast.success("Updated successfully");

        clearForm(); 
        setMode("create"); 
        window.history.replaceState({}, '', '/dashboard/maintype'); 
      } else {
      
        await axios.post(`${BASE_URL}/songmaintype`, formData);
        toast.success("Created successfully");
        clearForm();
      }
    } catch (err) {
      console.error(err);
      toast.error("Save failed");
    }  finally {
    setSaving(false); 
  }
  };

 

  return (
    <Box sx={{ p: { xs: 0.1, md: 1 } }}>
      <Paper elevation={3} sx={{ p: { xs: 1, md: 3 }, borderRadius: 3 }}>
       
        <Box display="flex" justifyContent="center" mt={1.5} mb={1.5}>
          <Box
            sx={{
              background: `linear-gradient(90deg, ${themeColor}, #ff6a6a)`,
              px: { xs: 2.5, md: 4 },
              py: { xs: 0.8, md: 1.1 },
              borderRadius: "8px 22px 8px 22px",
              boxShadow: "0 6px 16px rgba(255,92,110,0.35)"

            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "14px", md: "18px" },
                fontWeight: 900,
                color: "#fff",
                letterSpacing: "0.7px",
                textTransform: "uppercase",
              }}
            >
              Song Main Type
            </Typography>
          </Box>
        </Box>

        <Divider
          sx={{
            mb: { xs: 2, md: 3 },
            background: `linear-gradient(90deg, transparent, ${themeColor}, transparent)`,
            height: "2px",
            borderRadius: 5,
          }}
        />

        
        <Row gutter={[16, 16]} align="middle">
         
          <Col xs={24} sm={12} md={8}>
            <Typography
              fontWeight={600}
              mb={0.5}
              sx={{ color: themeColor, fontSize: { xs: "13px", md: "14px" } }}
            >
              Main Type Name
            </Typography>
            <TextField
              size="small"
              fullWidth
              placeholder="Enter main type name"
              value={mainTypeName}
              onChange={(e) => setMainTypeName(e.target.value)}
                      sx={{
  "& .MuiOutlinedInput-root": {
    minHeight: 40,               
    "& fieldset": { borderColor: "#ccc" },
    "&:hover fieldset": { borderColor: "#aaa" },
    "&.Mui-focused fieldset": { borderColor: "#aaa" },
  },

  "& .MuiInputBase-input": {
    fontSize: "13px",              
    padding: "8.5px 12px",         
    boxSizing: "border-box",
  },
}}
            />
          </Col>

         
          <Col xs={24} sm={12} md={8}>
            <Typography
              fontWeight={600}
              mb={1}
              sx={{ color: themeColor, fontSize: { xs: "13px", md: "14px" } }}
            >
              Status
            </Typography>
            <Radio.Group
              value={isActive}
              onChange={(e) => setIsActive(e.target.value)}
            >
              <Radio value={1}>
                <Tag color="green">Active</Tag>
              </Radio>
              <Radio value={0}>
                <Tag color="red">Deactive</Tag>
              </Radio>
            </Radio.Group>
          </Col>

         
          <Col xs={24} sm={12} md={8}>
            <Typography
              fontWeight={600}
              mb={1}
              sx={{ color: themeColor, fontSize: { xs: "13px", md: "14px" } }}
            >
              Upload Photo
            </Typography>
            <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
              <input
                id="profile-upload"
                type="file"
                accept="image/*"
                hidden
                onChange={handleFileChange}
              />
              <label htmlFor="profile-upload">
                <MUIButton
                  variant="outlined"
                  component="span"
                 sx={{ fontWeight: 600, fontSize: { xs: "12px", md: "14px" }, borderColor: "#aaa", color: "#8b8989", "&:hover": { borderColor: themeColor, background: "rgba(255,92,110,0.08)" } }}
                >
                  Upload Photo
                </MUIButton>
              </label>

              {filePreviewProfile && (
                <Box position="relative">
                  <img
                    src={filePreviewProfile}
                    alt="preview"
                    style={{
                      width: 50,
                      height: 50,
                      borderRadius: 6,
                      objectFit: "cover",
                      border: `1px solid ${themeColor}`,
                    }}
                  />
                  <CloseIcon
                    onClick={removeFile}
                    sx={{
                      position: "absolute",
                      top: -6,
                      right: -6,
                      cursor: "pointer",
                      background: "#fff",
                      borderRadius: "50%",
                      fontSize: 16,
                      color: themeColor,
                    }}
                  />
                </Box>
              )}
            </Box>
          </Col>
        </Row>

   
        <Box
          display="flex"
          justifyContent="end"
          mt={4}
          gap={1.5}
          flexWrap={{ xs: "wrap", md: "nowrap" }}
        >
          <Button
            icon={<SaveOutlined />}
            type="primary"
            size="middle"
            onClick={handleSave}
             loading={saving}        
  disabled={saving}
            style={{
              background: themeColor,
              borderRadius: 25,
              padding: "4px 20px",
              fontSize: 13,
            }}
          >
            {mode === "edit" ? "Update" : "Save"}
          </Button>

          <Button
            icon={<InfoCircleOutlined />}
            size="middle"
            onClick={() => navigate("/dashboard/maintypelist")}
            style={{
              borderRadius: 25,
              padding: "4px 20px",
              fontSize: 13
              ,color:"red",borderColor:"red"
            }}
            onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = "#ffe6e9";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = "transparent";
  }}
          >
            Details
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
